(() => {
    function enhanceReadingPath(path) {
        const picker = path?.querySelector?.('[data-am-reading-path-picker]');
        if (!picker || path.hasAttribute('data-am-reading-path-enhanced')) {
            return false;
        }

        function setOpen(open) {
            picker.setAttribute('aria-expanded', String(open));
            path.toggleAttribute('data-am-reading-path-open', open);
        }

        picker.addEventListener('click', () => {
            setOpen(picker.getAttribute('aria-expanded') !== 'true');
        });
        path.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && picker.getAttribute('aria-expanded') === 'true') {
                setOpen(false);
                picker.focus();
            }
        });

        path.setAttribute('data-am-reading-path-enhanced', '');
        picker.hidden = false;

        return true;
    }

    function initBirthchartReadingPaths(documentObject = document) {
        const paths = Array.from(
            documentObject?.querySelectorAll?.('[data-am-birthchart-reading-path]') ?? []
        );

        for (const path of paths) {
            enhanceReadingPath(path);
        }

        return paths.length;
    }

    if (typeof document !== 'undefined') {
        if (document.readyState === 'loading') {
            document.addEventListener(
                'DOMContentLoaded',
                () => initBirthchartReadingPaths(),
                {once: true}
            );
        } else {
            initBirthchartReadingPaths();
        }
    }

    if (typeof module !== 'undefined' && module.exports) {
        module.exports = {
            enhanceReadingPath,
            initBirthchartReadingPaths,
        };
    }
})();
